import { Btn, inputCls } from "@/components/common";
import PassportScanner from "@/components/PassportScanner";
import { EMPTY_GUEST, scanToGuest } from "@/lib/bookingUtils";

export function ExtraGuests({ guests, onChange }) {
  const list = guests || [];
  const add = () => onChange([...list, { ...EMPTY_GUEST, _uid: Math.random().toString(36).slice(2) }]);
  const del = (i) => onChange(list.filter((_, idx) => idx !== i));
  const patch = (i, p) => {
    const g = [...list];
    g[i] = { ...g[i], ...p };
    onChange(g);
  };
  const scan = (i, data, url) => patch(i, scanToGuest(data, url));

  return (
    <div className="border-t border-slate-200 pt-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold text-slate-700">Altri ospiti ({list.length})</span>
        <Btn type="button" variant="secondary" className="!py-1.5" onClick={add} data-testid="add-guest-btn">+ Aggiungi ospite</Btn>
      </div>
      <div className="space-y-3">
        {list.map((g, i) => (
          <div key={g._uid || i} className="rounded-md border border-slate-200 p-3 bg-slate-50/60" data-testid={`extra-guest-${i}`}>
            <div className="flex items-center justify-between mb-2">
              <PassportScanner onResult={(d, url) => scan(i, d, url)} compact />
              <button type="button" onClick={() => del(i)} className="text-slate-400 hover:text-red-600 text-sm">Rimuovi</button>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input value={g.name} onChange={(e) => patch(i, { name: e.target.value })} className={inputCls} placeholder="Nome" data-testid={`guest-name-${i}`} />
              <input value={g.surname} onChange={(e) => patch(i, { surname: e.target.value })} className={inputCls} placeholder="Cognome" />
              <input value={g.passport_number} onChange={(e) => patch(i, { passport_number: e.target.value })} className={inputCls} placeholder="Passaporto" />
              <input value={g.nationality} onChange={(e) => patch(i, { nationality: e.target.value })} className={inputCls} placeholder="Nazionalità" />
            </div>
            {g.passport_image && <img src={g.passport_image} alt="pp" className="h-16 mt-2 rounded border border-slate-200 object-contain" />}
          </div>
        ))}
      </div>
    </div>
  );
}
